import { Flex, HStack } from '@chakra-ui/react';
import FilterConditionPicker from '../atoms/FilterConditionPicker';
import { ChangeCriteria, UpdateRule } from '../useCreateDataValidation';
import CriteriaPicker from '../atoms/CriteriaPicker';
import { ValidationRule } from '../../../../../../sheet/types';

interface ValidationRuleProps {
  rule: ValidationRule;
  changeCriteria: ChangeCriteria;
  updateRule: UpdateRule;
}
const RuleCriteriaCondition = ({
  rule,
  changeCriteria,
  updateRule,
}: ValidationRuleProps) => {
  const criteria = rule.criteria;

  return (
    <HStack>
      <CriteriaPicker criteria={criteria} changeCriteria={changeCriteria} />

      <FilterConditionPicker
        criteria={criteria}
        rule={rule}
        updateRule={updateRule}
      />
    </HStack>
  );
  // return (
  //   <Flex alignItems="center" justifyContent="space-between" padding="5px 0px">
  //     <Flex width="49%">
  //       <CriteriaPicker criteria={criteria} changeCriteria={changeCriteria} />
  //     </Flex>
  //     <Flex width="49%">
  //       <FilterConditionPicker
  //         criteria={criteria}
  //         rule={rule}
  //         updateRule={updateRule}
  //       />
  //     </Flex>
  //   </Flex>
  // );
};

export default RuleCriteriaCondition;
